import { style } from '@vanilla-extract/css';
import { spacingVars } from '@tundr/ds-foundations';
import { themeVars } from '@tundr/theme';

const STACK_BOTTOM_OFFSET = '90px';

export const toastStackClass = style({
  position: 'fixed',
  right: themeVars.space.x10,
  bottom: STACK_BOTTOM_OFFSET,
  zIndex: themeVars.zIndex.toast,
  display: 'flex',
  flexDirection: 'column-reverse',
  alignItems: 'flex-end',
  gap: spacingVars.md,
});
